import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function norm(x){
  x=x||{};
  return Object.freeze({
    key:x.key||null,
    previous:x.previous===undefined?null:x.previous,
    current:x.current===undefined?null:x.current,
    verification:['VERIFIED','PARTIAL','UNVERIFIED'].includes(x.verification)?x.verification:'UNVERIFIED',
    materiality:Number.isFinite(x.materiality)?Math.max(0,Math.min(1,x.materiality)):null,
    domain:x.domain||'UNKNOWN'
  });
}
function changed(x){
  const n=norm(x);
  return JSON.stringify(n.previous)!==JSON.stringify(n.current);
}
function meaningful(x){
  const n=norm(x);
  if(!changed(n)) return false;
  if(n.materiality===null) return n.verification==='VERIFIED';
  if(n.verification==='UNVERIFIED') return false;
  return n.materiality>=0.5;
}
function classify(x){
  const n=norm(x);
  if(!changed(n)) return 'NO_CHANGE';
  if(n.verification==='UNVERIFIED') return 'UNVERIFIED_CHANGE';
  if(meaningful(n)) return 'MEANINGFUL_CHANGE';
  return 'MINOR_CHANGE';
}
function scan(items){
  const rows=Array.isArray(items)?items:[];
  const out=rows.map(x=>Object.freeze({...norm(x),classification:classify(x)}));
  return Object.freeze({
    meaningful:Object.freeze(out.filter(x=>x.classification==='MEANINGFUL_CHANGE')),
    minor:Object.freeze(out.filter(x=>x.classification==='MINOR_CHANGE')),
    unverified:Object.freeze(out.filter(x=>x.classification==='UNVERIFIED_CHANGE')),
    unchanged:Object.freeze(out.filter(x=>x.classification==='NO_CHANGE')),
    tradeSignal:false
  });
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  ok('equal values are no change',classify({previous:1,current:1,verification:'VERIFIED',materiality:1})==='NO_CHANGE');
  ok('verified material change detected',classify({previous:1,current:2,verification:'VERIFIED',materiality:.8})==='MEANINGFUL_CHANGE');
  ok('partial material change can be meaningful',classify({previous:1,current:2,verification:'PARTIAL',materiality:.8})==='MEANINGFUL_CHANGE');
  ok('unverified change stays unverified',classify({previous:1,current:2,verification:'UNVERIFIED',materiality:1})==='UNVERIFIED_CHANGE');
  ok('small verified change remains minor',classify({previous:1,current:1.01,verification:'VERIFIED',materiality:.1})==='MINOR_CHANGE');
  ok('unknown materiality requires verified evidence',meaningful({previous:'A',current:'B',verification:'VERIFIED'})===true);
  ok('unknown materiality partial evidence is not promoted',meaningful({previous:'A',current:'B',verification:'PARTIAL'})===false);
  const s=scan([
    {previous:1,current:2,verification:'VERIFIED',materiality:.9},
    {previous:1,current:1,verification:'VERIFIED',materiality:.9},
    {previous:1,current:2,verification:'UNVERIFIED',materiality:.9}
  ]);
  ok('scan separates meaningful change',s.meaningful.length===1);
  ok('scan separates unchanged',s.unchanged.length===1);
  ok('scan separates unverified change',s.unverified.length===1);
  ok('scan remains non-trading',s.tradeSignal===false);
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,changed,meaningful,classify,scan,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestMeaningfulChangeDetector=Object.freeze(API);
})(engineContext);
